/** @format */

// export const uniquesByTicketIdAndScanned = data => {
// 	// Step 1: Group the data by ticket_id
// 	const groupedData = data.reduce((groups, item) => {
// 		const key = item.ticket_id;
// 		if (!groups[key]) {
// 			groups[key] = [];
// 		}
// 		groups[key].push(item);
// 		return groups;
// 	}, {});

// 	// Step 2: For each group, find the object with the latest scanned value
// 	const filteredData = Object.values(groupedData).map(group => {
// 		const latestScanned = group.reduce((latest, item) => {
// 			if (!latest || new Date(item.scanned) > new Date(latest.scanned)) {
// 				return item;
// 			}
// 			return latest;
// 		}, null);

// 		return latestScanned;
// 	});

//   const sortedScans = filteredData.slice().sort((a, b) => new Date(b.scanned) - new Date(a.scanned));

// 	return sortedScans;
// };

// https://www.geeksforgeeks.org/javascript/javascript-merge-two-sorted-arrays/
// Efficiently merges two sorted arrays into one sorted array.
// WILL miss items if the arrays are not presorted. TODO: add sanity checks to error out
export const mergeSortedArrays = <T1, T2>(a1: T1[], a2: T2[], cmp: (a: T1, b: T2) => number): (T1 | T2)[] => {
	// bail out early if either is empty
	if (a1.length === 0) return a2;
	if (a2.length === 0) return a1;

	let i = 0,
		j = 0,
		res: (T1 | T2)[] = [];

	while (i < a1.length && j < a2.length) {
		if (cmp(a1[i], a2[j]) <= 0) {
			res.push(a1[i]);
			i++;
		} else {
			res.push(a2[j]);
			j++;
		}
	}

	// If any elements remain in a1 or a2, add them to the res
	while (i < a1.length) {
		res.push(a1[i]);
		i++;
	}

	while (j < a2.length) {
		res.push(a2[j]);
		j++;
	}

	return res;
};
